export default "__VITE_ASSET__Dq2ln02f__"